import { Accept, Cancel } from 'Common/Components/Button/styled';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { setFieldsTool } from 'store/Agents/actions';
import { selectToolsVariables } from 'store/Agents/selectors';
import Card from '../Card';
import Toolbar from '../Toolbar/styled';
import WebSiteButton from '../WebsiteButton';
import {
  Wrapper, Title, Content, WrapperField, Label, Field, WrapperTitle, ButtonsContainer,
  WrapperPasswordInput, PasswordInput
} from './styled';

const ConfigureTool = ({ tool, onClose }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const props = useSelector((state) => ({
    variables: selectToolsVariables(state, tool.name)
  }));
  const [fields, setFields] = useState(props.variables);
  const optionalEnvVar = get(tool, 'optional_environment_variables', false);
  const passwordTypeVars = [
    '_API_KEY',
    '_SECRET_KEY',
    '_PASSWORD',
    '_SECRET',
    '_PASSWD',
    '_KEY_SECRET',
    '_PASSW',
    '_TOKEN'
  ];

  // environmentVariables=son las env var de la tool, estan definidas en selector.
  // variables=esta en el reducer y contiene las env var que defnio el usuario en el wizard.
  // TODO: unificar esto. emprolijar.
  const onChange = (e) => {
    // guardo el estado de los campos
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    const newFields = { ...fields };
    newFields[fieldName] = fieldValue;
    setFields(newFields);
  };

  const onChangePasswordInput = (name, value) => {
    setFields(prev => ({ ...prev, [name]: value }));
  };

  const onSave = () => {
    // persisto en el reducecr los datos.
    const filledFields = Object.fromEntries(Object.entries(fields).filter(([_, value]) => value));
    dispatch(setFieldsTool(tool.name, filledFields));
    onClose();
  };

  return (
    <Wrapper>
      <WrapperTitle>
        <Title>{intl.formatMessage({ id: 'agents.createAgent.wizard.chooseTools.toolCollection.configureTool.title' })}</Title>
        <ButtonsContainer>
          <Cancel id="modal-agents-tools-configure-back" onClick={ onClose }>{intl.formatMessage({ id: 'agents.createAgent.wizard.chooseTools.toolCollection.configureTool.back' })}</Cancel>
          <Accept id="modal-agents-tools-configure-save" onClick={ onSave }>{intl.formatMessage({ id: 'agents.createAgent.wizard.chooseTools.toolCollection.configureTool.save' })}</Accept>
        </ButtonsContainer>
      </WrapperTitle>
      <Card key={ tool.title } title={ tool.title } description={ tool.description } image={ tool.name } toolbar={ <Toolbar><WebSiteButton url={ tool.website } /></Toolbar> } />
      <Content>
        {
          tool.environment_variables.map((item) =>
            passwordTypeVars.some(el => item.endsWith(el))
              ? <WrapperPasswordInput key={ item }>
                <PasswordInput key={ item } id={ `modal-agents-tools-configure-${item}` } name={ item } onChange={ (value) => onChangePasswordInput(item, value) } title={ `${item}(*)` } value={ props.variables[item] } />
                </WrapperPasswordInput>
              : (
                <WrapperField key={ item }>
                  <Label>{ `${item}(*)` }</Label>
                  <Field id={ `modal-agents-tools-configure-${item}` } name={ item } onChange={ onChange } defaultValue={ props.variables[item] } />
                </WrapperField>
                )
          )
        }
        {
          optionalEnvVar && optionalEnvVar.map((item) =>
            passwordTypeVars.some(el => item.endsWith(el))
              ? <WrapperPasswordInput key={ item }>
                <PasswordInput key={ item } id={ `modal-agents-tools-configure-${item}` } name={ item } onChange={ (value) => onChangePasswordInput(item, value) } title={ item } value={ props.variables[item] } />
                </WrapperPasswordInput>
              : (
                <WrapperField key={ item }>
                  <Label>{ item }</Label>
                  <Field id={ `modal-agents-tools-configure-${item}` } name={ item } onChange={ onChange } defaultValue={ props.variables[item] } />
                </WrapperField>
                )
          )
        }
        <Label>(*) Required</Label>
      </Content>
    </Wrapper>
  );
};

export default ConfigureTool;
